export default "__VITE_ASSET__BZ5V94pI__"